import { csrfToken } from './csrf';

// Media upload function for photos/videos (up to 30MB)
export async function uploadMediaFile(
  file: File,
  prefix?: string,
): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);
  if (prefix) {
    formData.append('prefix', prefix);
  }

  const response = await fetch('/api/files/upload-media', {
    method: 'POST',
    headers: { 'X-CSRF-Token': csrfToken() },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to upload media');
  }

  const data = await response.json();
  return data.url as string;
}
